import { Component, HostListener, inject, OnInit } from '@angular/core';
import { EventType, Router, RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../../service/layout.service';
import { Avatar } from "primeng/avatar";
import { Button } from "primeng/button";
import { ThemeSelectButtonComponent } from "../theme-select-button/theme-select-button.component";
import { AuthService } from "../../../auth/services/auth.service";
import Utils from "../../../../shared/utils";
import { UserPanelComponent } from "../user-panel/user-panel.component";

@Component({
  selector: 'app-topbar',
  imports: [RouterModule, CommonModule, StyleClassModule, Avatar, Button, ThemeSelectButtonComponent, NgOptimizedImage, UserPanelComponent],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent implements OnInit {
  loginLink: any[] = ['/auth/login'];
  protected authService = inject(AuthService);
  protected router = inject(Router);
  protected readonly AuthService = AuthService;
  isScrolled = false;

  constructor(public layoutService: LayoutService) {
  }

  ngOnInit() {
    this.authService.refreshUserInfo();

    this.router.events.subscribe(event => {
      if (event.type === EventType.ActivationEnd) {
        this.loginLink = Utils.getLoginRouteWithRedirect(this.router);
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 10;
  }
}
